import { fetchVideosByCategory, assignVideo } from './ajax.js';
import { assignVideoStore, stageVideoStore } from './store.js';

let videoListContainer = null;
let form = null;

/**
 * Initialize select videos form (popup)
 */
export function initSelectForm() {
	form = document.getElementById('select-videos-form');
	if (!form) return;

	videoListContainer = form.querySelector('.video-list');

	// Setup event delegation for checkboxes
	if (videoListContainer) {
		videoListContainer.addEventListener('change', handleCheckboxChange);
	}

	// Category buttons
	const categoryBtns = form.querySelectorAll('.category-btn');
	categoryBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			categoryBtns.forEach(b => b.classList.remove('active'));
			btn.classList.add('active');
			const category = btn.getAttribute('data-category');
			loadVideos(category);
		});
	});

	// Listen for popup open event
	document.addEventListener('popup-opened', handlePopupOpen);

	// Form submit
	form.addEventListener('submit', handleFormSubmit);
}

function handlePopupOpen(e) {
	if (e.detail?.target !== 'select-videos') return;

	// Sync selected videos from stage videos
	const videoIds = stageVideoStore.getVideoIds();
	assignVideoStore.setSelectedVideos(videoIds);

	// Load default category when popup opens
	const activeBtn = form?.querySelector('.category-btn.active');
	if (activeBtn) {
		loadVideos(activeBtn.getAttribute('data-category'));
	}
}

async function loadVideos(category) {
	if (!videoListContainer) return;

	// Check cache first
	const cached = assignVideoStore.getVideosByCategory(category);
	if (cached) {
		videoListContainer.innerHTML = cached;
		syncCheckboxState();
		return;
	}

	// Show skeleton
	videoListContainer.innerHTML = Array.from({ length: 4 }, () => `
		<div class="animate-pulse">
			<div class="flex items-center gap-2">
				<div class="w-5 h-5 rounded bg-gray-200 shrink-0"></div>
				<div class="flex items-start p-4 gap-4 flex-1">
					<div class="w-[146px] h-28 rounded-[10px] bg-gray-200 shrink-0"></div>
					<div class="flex flex-col gap-2 flex-1 pt-1">
						<div class="h-4 bg-gray-200 rounded w-3/4"></div>
						<div class="h-3 bg-gray-200 rounded w-1/2"></div>
						<div class="h-3 bg-gray-200 rounded w-1/3"></div>
					</div>
				</div>
			</div>
		</div>
	`).join('');

	// Fetch from API
	const html = await fetchVideosByCategory(category);

	if (html !== null) {
		videoListContainer.innerHTML = html || '<div class="col-span-2 text-center py-4 text-gray-500">' + wpcore.direct_t({ en: 'No videos found', fr: 'Aucune vid\u00e9o trouv\u00e9e' }) + '</div>';
		assignVideoStore.addVideosByCategory(category, html);
	} else {
		videoListContainer.innerHTML = '<div class="col-span-2 text-center py-4 text-red-500">' + wpcore.direct_t({ en: 'Error loading videos', fr: 'Erreur lors du chargement des vid\u00e9os' }) + '</div>';
	}

	syncCheckboxState();
}

function handleCheckboxChange(e) {
	const checkbox = e.target;
	if (checkbox.type !== 'checkbox') return;

	if (checkbox.checked) {
		assignVideoStore.addVideo(checkbox.value);
	} else {
		assignVideoStore.removeVideo(checkbox.value);
	}
}

function syncCheckboxState() {
	if (!videoListContainer) return;
	const checkboxes = videoListContainer.querySelectorAll('.video-item input[type="checkbox"]');
	checkboxes.forEach(checkbox => {
		checkbox.checked = assignVideoStore.isSelected(checkbox.value);
	});
}

async function handleFormSubmit(e) {
	e.preventDefault();
	const form = e.target;
	const stageId = form.querySelector('input[name="stage-id"]').value;
	const videoIds = assignVideoStore.getSelectedVideos();

	const success = await assignVideo(stageId, videoIds);

	if (success) {
		wpcore.closePopup('select-videos');
		document.dispatchEvent(new CustomEvent('stage-videos-reload'));
	} else {
		alert(wpcore.direct_t({ en: 'Failed to assign videos', fr: '\u00c9chec de l\'attribution des vid\u00e9os' }));
	}
}
